import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Footer() {
    const {t} = useTranslation()
  return (
    <section className="section footer">
        <div className="container">
            <div className="footer__container">
                <div className="footer__logo_container">
                    <Link to="/" className='navbar__logo'><img src="https://res.cloudinary.com/dvvsyxugn/image/upload/v1690355560/logo-white_ziqt3y.png" alt="DADY Consulting logo" /></Link>
                </div>
                <div className="footer__contact_container deleted">
                    <p>Phone</p>
                    <p>Email</p>
                    <p>Adresse</p>
                </div>
                <div className="footer__contact_container adress">
                    <p>Adresse</p>
                </div>
                <div className="footer__social_container">
                    <Link to='#' className='footer__social_link'>FACEBOOK</Link>
                    <Link to='#' className='footer__social_link'>TWITTER</Link>
                    <Link to='#' className='footer__social_link'>INSTAGRAM</Link>
                    <Link to='#' className='footer__social_link'>LINKEDIN</Link>
                </div>
            </div>            
        </div>
    </section>
  )
}

export default Footer;